import templateUrl from './component.tpl.html';
import ExportsListviewController from './controller';

angular
    .module('festzelt-os.components')
    .component('listviewExportsTable', {
        bindings: {
            store: '=',
        },
        controller: ExportsListviewController,
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/components/state-manager/listview/exports-table/component.js